import { isMITX } from './utils/stackUtils';

const defaultModuleConfig = isMITX()
  ? {
      manageMembers: false,
      manageProjects: false,
      managePathways: true,
      enablePathwayAdding: false,
      enablePathwayDeletion: true,
      enablePathwayDuplication: false,
      enablePathwayLocking: false,
      enablePathwayEditing: false,
      manageSystems: false,
      manageModules: false,
      enablePathwayNavigator: false,
      enableChangelog: false,
      enableHowTos: false,
      enableWalkthroughs: false,
      enableMoocDashboard: true,
      enableRegistration: true,
      enableMonteCarloSimulation: false,
    }
  : {
      manageMembers: true,
      manageProjects: true,
      managePathways: true,
      enablePathwayAdding: true,
      enablePathwayDeletion: true,
      enablePathwayDuplication: true,
      enablePathwayLocking: true,
      enablePathwayEditing: true,
      manageSystems: true,
      manageModules: true,
      enablePathwayNavigator: true,
      enableChangelog: true,
      enableHowTos: true,
      enableWalkthroughs: true,
      enableMoocDashboard: false,
      enableRegistration: false,
      enableMonteCarloSimulation: true,
    };

export default defaultModuleConfig;
